export const exceedsMax = (selector, maxHeight = 66) => {
  if (typeof window === 'undefined') return null
  const element = document.querySelector(selector)
  return element ? element.scrollHeight > maxHeight : null
}
